import { Link } from "react-router-dom";
import { Phone } from "lucide-react";

export default function Navbar() {
  return (
    <nav
      data-testid="main-nav"
      className="fixed top-0 left-0 right-0 z-50 backdrop-blur-xl bg-white/70 border-b border-black/5"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-12 h-16 flex items-center justify-between">
        <Link
          to="/"
          data-testid="nav-logo"
          className="flex items-center gap-3"
        >
          <img src="/assets/logo-des-icon.png" alt="D.E.S Déménagements" className="h-10 md:h-12 w-auto" />
        </Link>

        <div className="hidden md:flex items-center gap-10 text-sm text-neutral-700 font-medium">
          <a href="#services" data-testid="nav-link-services" className="hover:text-black transition">
            Services
          </a>
          <a href="#estimateur" data-testid="nav-link-estimateur" className="hover:text-black transition inline-flex items-center gap-1.5">
            <span className="w-1.5 h-1.5 rounded-full bg-[#FF2800] animate-pulse" />
            Estimateur
          </a>
          <a href="#avis" data-testid="nav-link-avis" className="hover:text-black transition">
            Avis
          </a>
          <a href="#about" data-testid="nav-link-about" className="hover:text-black transition">
            Qui sommes-nous
          </a>
          <a href="#zones" data-testid="nav-link-zones" className="hover:text-black transition">
            Zones
          </a>
          <a href="#contact" data-testid="nav-link-contact" className="hover:text-black transition">
            Contact
          </a>
        </div>

        <div className="flex items-center gap-3">
          <a
            href="tel:0753221529"
            data-testid="nav-phone"
            className="hidden sm:flex items-center gap-2 text-sm text-neutral-700 hover:text-black transition"
          >
            <Phone size={14} />
            <span className="font-medium">07 53 22 15 29</span>
          </a>
          <Link
            to="/devis"
            data-testid="nav-cta-devis"
            className="btn-red px-5 py-2.5 rounded-full text-sm font-semibold"
          >
            Devis gratuit
          </Link>
        </div>
      </div>
    </nav>
  );
}
